import { type CreatorPermission, type TeamMemberDto } from '@api'

import type { CreatorFeatures } from '../accounts/types'

export interface Creator {
  id: number
  onlyfansId: number
  name: string
  userName: string
  deletable: boolean
  status: Array<CreatorStatus>
  plan: string
  features: CreatorFeatures[]
  licenseId: number
  upgradableLicenses: string[]
  avatar: {
    croppedUrl: string | null
  }
  lists: Array<OnlyFansList>
  permissions: string[]
  browserProfile: BrowserProfile
  proxySettingsOnLaunch: boolean
}

export const enum CreatorStatus {
  /** Owner hasnt got any license that could be attached */
  NotLicensable = 'NotLicensable',
  /** Owner has license that could be attached */
  Licensable = 'Licensable',
  /** There is a license but it isn't paid */
  NotPaid = 'NotPaid',
  /** Owner has no license left to upgrade */
  NotUpgradeable = 'NotUpgradeable',
  /** Owner has upgrade left that could be used */
  Upgradeable = 'Upgradeable',
}

export interface CreatorState {
  error: unknown
}

export type ProxyStatus =
  | 'AutomationsRunning'
  | 'AutomationsNotRunning'
  | 'ProxyFailing'
  | 'NotLoggedIn'

export interface CreatorProxyStatus {
  id: number
  onlyfansId: number
  status: ProxyStatus
}

export interface CreatorContext {
  selection: {
    selectableCreators: Creator[]
    selectedCreators: Creator[]
    allSelect: () => void
    allRemove: () => void
    addSelect: (creator: Creator) => void
    removeSelect: (creator: Creator) => void
    setSelect: (creator: Creator[]) => void
    defaultSelectedCreators: boolean
  }
}

export interface CreatorsPermissions {
  display: boolean
  displayName: string
  value: string
}

export enum CreatorPermissionState {
  On,
  Off,
  Inherited,
}

export interface BrowserProfile {
  createdAt: string
  id: number
  proxySettings: ProxySettings
  updatedAt: string
}

export interface ProxySettings {
  automaticProxy: boolean | null
  host: string
  password: string
  proxyType: null | 'NONE' | 'AUTOMATIC' | 'HTTP'
  username: string
}

export interface OnlyFansList {
  internalOrderNumber: number
  type: string
  name: string
  usersCount: number
  postsCount: number
  canUpdate: boolean
  canDelete: boolean
  canManageUsers: boolean
  canAddUsers: boolean
  canPinnedToUsers: boolean
  canPinnedToFeed: boolean
  canPinnedToChat: boolean
  order: string
  direction: string
  pinnedToFeed: boolean
  pinnedToChat: boolean
  id: string
}

export interface UpdateCreatorAccessRequest {
  permissions: Record<TeamMemberDto['id'], Array<CreatorPermission>>
}

export interface CreatorCompensationBody {
  fixedSalary: {
    amount: number
    retention: 'Monthly' | 'Yearly'
  }
  cutOfRevenuePercentage: number
}
